<p-toast />
<div class="full-wrapper flex-center min-h-screen">
  <p-card class="institution-card flex-column gap-4">
    <ng-template pTemplate="header">
      <div class="flex-center pt-4 full-width gap-5">
        <img src="/assets/images/logo.png" class="logo" alt="Edoha Logo" style="width: 50px; height: auto;" />
        <h1 class="text-2xl font-bold ml-2">edoha</h1>
      </div>
    </ng-template>

    @if (loading) {
      <div class="flex-center full-width py-4">
        <i class="pi pi-spin pi-spinner text-4xl"></i>
      </div>
    } @else if (institutions.length === 0) {
      <div class="flex flex-column align-items-center gap-4">
        <i class="pi pi-building text-5xl text-secondary"></i>
        <p class="text-center text-lg">Você não está associado a nenhuma instituição.</p>
        <button
          type="button"
          class="flex-center btn btn-2"
          (click)="logout()">
          <i class="pi pi-sign-out"></i>
          Sair
        </button>
      </div>
    } @else if (institutions.length > 1) {
      <div class="flex flex-column gap-3">
        <p class="text-center text-lg font-medium">Selecione uma instituição para continuar:</p>
        @for (institution of institutions; track institution.id) {
          <button
            type="button"
            class="flex-center full-width btn btn-1 institution-btn"
            (click)="selectInstitution(institution)">
            <i class="pi pi-building"></i>
            {{ institution.name }}
          </button>
        }
      </div>
    }
  </p-card>
</div>
